import React, { useState } from 'react';
import './ContactUs.scss';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import { Button } from '../../components/ui';
import useInput from '../../components/hooks/use.input';
import { Modal } from 'react-bootstrap';

const ContactUs = () => {
  const [show, setShow] = useState(false);

  const {
    value: fullName,
    isValid: enteredFullNameIsValid,
    hasError: fullNameInputHasError,
    valueChangeHandler: fullNameChangedHandler,
    inputBlurHandler: fullNameBlurHandler,
    reset: resetFullNameInput,
    error: fullNameError,
  } = useInput(value => {
    if (value.length === 0) {
      return { isValid: false, error: 'Enter your name' };
    } else if (value.length <= 1) {
      return { isValid: false, error: 'Minimum Character is 2' };
    } else {
      return { isValid: true, error: '' };
    }
  });

  const {
    value: email,
    isValid: enteredEmailIsValid,
    hasError: emailInputHasError,
    valueChangeHandler: emailChangedHandler,
    inputBlurHandler: emailBlurHandler,
    reset: resetEmailInput,
    error: emailError,
  } = useInput(value => {
    if (value.length === 0) {
      return { isValid: false, error: 'Enter email' };
    } else if (!value.includes('@')) {
      return { isValid: false, error: 'Invalid email address' };
    } else {
      return { isValid: true, error: '' };
    }
  });

  const {
    value: country,
    isValid: enteredCountryIsValid,
    hasError: countryInputHasError,
    valueChangeHandler: countryChangedHandler,
    inputBlurHandler: countryBlurHandler,
    reset: resetCountryInput,
    error: countryError,
  } = useInput(value => {
    if (value.length === 0) {
      return { isValid: false, error: 'Select your country' };
    } else {
      return { isValid: true, error: '' };
    }
  });

  const {
    value: area,
    isValid: enteredAreaIsValid,
    hasError: areaInputHasError,
    valueChangeHandler: areaChangedHandler,
    inputBlurHandler: areaBlurHandler,
    reset: resetAreaInput,
    error: areaError,
  } = useInput(value => {
    if (value.length === 0) {
      return { isValid: false, error: 'Select subject' };
    } else {
      return { isValid: true, error: '' };
    }
  });

  const {
    value: inquiry,
    isValid: enteredInquiryIsValid,
    hasError: inquiryInputHasError,
    valueChangeHandler: inquiryChangedHandler,
    inputBlurHandler: inquiryBlurHandler,
    reset: resetInquiryInput,
    error: inquiryError,
  } = useInput(value => {
    if (value.length === 0) {
      return { isValid: false, error: 'Enter message' };
    } else if (value.length <= 1) {
      return { isValid: false, error: 'Minimum Character is 2' };
    } else {
      return { isValid: true, error: '' };
    }
  });

  const handleClickSubmit = () => {
    fullNameBlurHandler(true);
    emailBlurHandler(true);
    inquiryBlurHandler(true);
    countryBlurHandler(true);
    areaBlurHandler(true);
    if (
      enteredFullNameIsValid &&
      enteredEmailIsValid &&
      enteredCountryIsValid &&
      enteredAreaIsValid &&
      enteredInquiryIsValid
    ) {
      //TODO
      resetFullNameInput();
      resetEmailInput();
      resetCountryInput();
      resetAreaInput();
      resetInquiryInput();
      handleShow();
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
  };

  return (
    <>
      <Breadcrumbs path={`help/Contact Us`} />
      <div className="contactus">
        <div className="wrapper">
          <div className="column column1">
            <h2>Send us a message</h2>
            <form action="">
              <div className="fieldset">
                <div className="form-fields">
                  <div className="input-container">
                    <div className="half left">
                      <select
                        id="country"
                        className="input form-select valid"
                        name="country"
                        onBlur={countryBlurHandler}
                        onChange={countryChangedHandler}
                        value={country}
                      >
                        <option value="">Select your country</option>
                        <option>United States</option>
                        <option>France</option>
                        <option>China</option>
                        <option>India</option>
                        <option>Others (include in the message)</option>
                      </select>
                      <span className="required">*</span>
                      <span className={`has-error${countryInputHasError ? ' show' : ''}`}>
                        {countryError}
                      </span>
                    </div>
                    <div className="half left">
                      <select
                        id="subject-area"
                        className="input form-select subject-area"
                        name="area"
                        onBlur={areaBlurHandler}
                        onChange={areaChangedHandler}
                        value={area}
                      >
                        <option value="">Choose subject area</option>
                        <option>Sales</option>
                        <option>Website</option>
                      </select>
                      <span className="required">*</span>
                      <span className={`has-error${areaInputHasError ? ' show' : ''}`}>
                        {areaError}
                      </span>
                    </div>
                  </div>
                  <div className="input-container">
                    <div className="half left">
                      <input
                        className={`input form-text valid ${
                          fullNameInputHasError ? 'invalid' : ''
                        }`}
                        placeholder="Your name"
                        type="text"
                        onBlur={fullNameBlurHandler}
                        onChange={fullNameChangedHandler}
                        value={fullName}
                      />
                      <span className="required">*</span>
                      <span className={`has-error${fullNameInputHasError ? ' show' : ''}`}>
                        {fullNameError}
                      </span>
                    </div>
                    <div className="half left">
                      <input
                        className={`input form-text valid ${emailInputHasError ? 'invalid' : ''}`}
                        placeholder="Your e-mail address"
                        type="text"
                        onBlur={emailBlurHandler}
                        onChange={emailChangedHandler}
                        value={email}
                      />
                      <span className="required">*</span>
                      <span className={`has-error${emailInputHasError ? ' show' : ''}`}>
                        {emailError}
                      </span>
                    </div>
                  </div>
                  <div className="input-container">
                    <textarea
                      className={`input form-textarea valid ${
                        inquiryInputHasError ? 'invalid' : ''
                      }`}
                      placeholder="Type in your message here…"
                      onBlur={inquiryBlurHandler}
                      onChange={inquiryChangedHandler}
                      value={inquiry}
                    ></textarea>
                    <span className="required">*</span>
                    <span className={`has-error${inquiryInputHasError ? ' show' : ''}`}>
                      {inquiryError}
                    </span>
                  </div>
                </div>
              </div>
              <div className="cta-container">
                <Button className="button" click={handleClickSubmit}>
                  Submit
                </Button>
              </div>
            </form>
          </div>
          <div className="column column2">
            <h2>Customer service hotline</h2>
            <div className="email-container">
              <a
                className="contact-icon contact-email-icon"
                href="mailto: contact@visionhub.com"
                target="_blank"
              >
                contact@visionhub.com
              </a>
            </div>
            <div className="email-container">
              <span className="contact-icon contact-tel-icon">1-888-8-1VISION</span>
              <p>(International rates will apply for call outside US)</p>
            </div>
            <h2>Customer service hours</h2>
            <div className="email-container">Monday to Friday: 9:00 to 18:00 CET</div>
          </div>
        </div>
      </div>
      <Modal show={show} backdrop="static" onHide={handleClose} className="contactUs-modal">
        <Modal.Header>
          <h2>SUCCESSFULLY SENT</h2>
        </Modal.Header>
        <Modal.Body>
          Your inquiry has been successfully sent to our <br /> Customer Service.
        </Modal.Body>
        <Modal.Footer>
          <Button click={handleClose}>Ok</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ContactUs;
